module.exports = __webpack_public_path__ + "img/dots-loader.fb749a2f.gif";